import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { errorMixin } from '../mixins/error-mixin'
import { i18n } from '../i18n'
import VReferenceSlider from '../components/VReferenceSlider.vue'
import VContactForm from '../components/VContactForm.vue'
import VTabsPath from '../components/VTabsPath.vue'
import VGallerySlider from '../components/VGallerySlider.vue'
import { app } from '../app'

createApp({
  components: {
    VReferenceSlider,
    VContactForm,
    VTabsPath,
    VGallerySlider
  },
  extends: app,
  mixins: [
    errorMixin
  ]
})
  .use(vuetify)
  .use(i18n)
  .mount('#app')
